<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg  px-4 py-5 border-b border-gray-200 sm:px-6">
    <h3 class="text-lg leading-6 font-medium text-gray-900">Текущие мероприятия</h3>
    <p class="mt-1 text-sm text-gray-500">Список мероприятий на которые вы можете подать заявку на участие. Прошедшие
      мероприятия вы можете в <a href="#" class="link">архиве</a></p>
    <ul role="list" class="mt-5 divide-y divide-gray-200">
      <li v-for="event in events" :key="event.id">
        <router-link :to="{name: 'EventDetails', params:{id: event.id}}" class="block hover:bg-gray-50">
          <div class="py-4">
            <div class="flex items-center justify-between">
              <p class="text-base font-medium text-primary-600">
                {{ event.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <p class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                  Активно
                </p>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <p class="flex items-center text-sm text-gray-500">
                  <UsersIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true"/>
                  {{ event.age }}
                </p>
                <p class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6">
                  <ColorSwatchIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true"/>
                  {{ event.theme }}
                </p>
              </div>
              <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                <CalendarIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true"/>
                <p>
                  до
                  {{ ' ' }}
                  <time :datetime="event.ended_at">{{ $date.formatDateLong(event.ended_at) }}</time>
                </p>
              </div>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>


</template>

<script>
import {CalendarIcon, ColorSwatchIcon, UsersIcon} from '@heroicons/vue/solid'


const positions = [
  {
    id: 1,
    title: 'II Международный интеллектуальный конкурс «Турнир Всезнаек»',
    type: 'Активно',
    location: 'окружающий мир',
    department: '6-7 лет',
    closeDate: '2020-01-07',
    closeDateFull: '3 марта',
  },
  {
    id: 2,
    title: 'Всероссийский конкурс «Мой родной русский язык»',
    type: 'Активно',
    location: 'математика, задания на логику',
    department: '12-16 лет',
    closeDate: '2020-01-07',
    closeDateFull: '15 декабря',
  },
  {
    id: 3,
    title: 'Всероссийская викторина «Вот оно какое, наше лето!»',
    type: 'Активно',
    location: 'Межпредметный, окружающий мир',
    department: '5-9 класс',
    closeDate: '2020-01-14',
    closeDateFull: '1 января',
  },
]
export default {
  components: {
    CalendarIcon,
    ColorSwatchIcon,
    UsersIcon,
  },
  setup() {
    return {
      positions,
    }
  },
  name: "EventsTimetable",
  data() {
    return {
      events: []
    }
  },
  async mounted() {
    this.events = await this.$api.events.all_active()
  }
}
</script>

<style scoped>

</style>